import Login from "@/views/Login/Login.vue";
import Loading from "@/views/Loading/Loading.vue"
import BasicLayout from "@/layouts/BasicLayout.vue";
import auth from "@/mixin/auth.mixin";
const routes = [
    /* Login view path */
    {
        path: "/",
        name: "Login",
        component: Login,
    },
    {
        path: "/login",
        beforeEnter() {
            // auth.methods.handleLogout()
            // console.log();
            auth.data().auth.getSession();
        },
        hidden: true,
    },
    {
        path: "/login/oauth2/code/cognito",
        component: Loading,
        hidden: true,
    },

    {
        path: "/list-user",
        component: BasicLayout,
        meta: {
            title: "list-user-title",
            icon: "mdi-account",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [{
                name: "List User",
                path: "",
                component: () =>
                    import ("@/views/ListUser/ListUser.vue"),
                meta: {
                    title: "list-user-title",
                },
            },
            {
                name: "Detail user",
                path: "detail-user/:username",
                component: () =>
                    import ("@/views/ListUser/DetailUser.vue"),
                meta: {
                    title: "detail-user-title",
                },
            },
            {
                name: "Activity log user",
                path: "activity-log/:id",
                component: () =>
                    import ("@/views/ActivityLog/ActivityLog.vue"),
                meta: {
                    title: "activity-log-title",
                },
            },
        ],
    },
    {
        path: "/list-teacher",
        component: BasicLayout,
        meta: {
            title: "list-teacher-title",
            icon: "mdi-teach",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [{
                name: "List Teacher",
                path: "",
                component: () =>
                    import ("@/views/Teacher/ListTeacher.vue"),
                meta: {
                    title: "list-teacher-title",
                },
            },
            {
                name: "Detail Teacher",
                path: "detail-teacher/:id/:username",
                component: () =>
                    import ("@/views/Teacher/DetailTeacher.vue"),
                meta: {
                    title: "detail-teacher-title",
                },
            },
            {
                name: "Activity log teacher",
                path: "activity-log/:id",
                component: () =>
                    import ("@/views/ActivityLog/ActivityLog.vue"),
                meta: {
                    title: "activity-log-title",
                },
            },
        ],
    },

    // {
    //     path: "/list-feedback",
    //     component: BasicLayout,
    //     meta: {
    //         title: "list-feedback-title",
    //         icon: "mdi-message-alert-outline",
    //         requiresAuth: true,
    //     },
    //     hideChildrenInMenu: true,
    //     children: [{
    //             name: "List Feedback",

    //             path: "/list-feedback",
    //             component: () =>
    //                 import ("@/views/Feedback/Feedback.vue"),
    //             meta: {
    //                 title: "list-feedback-title",
    //             },
    //         },
    //         {
    //             name: "Detail Feedback",
    //             path: "/list-feedback/detail-user/:id",
    //             component: () =>
    //                 import ("@/views/ListUser/DetailUser.vue"),
    //             meta: {
    //                 title: "detail-user-title",
    //             },
    //         },
    //     ],
    // },
    {
        path: "/confirm-log",
        component: BasicLayout,
        meta: {
            title: "confirm-log-title",
            icon: "mdi-file-document-outline",
            requiresAuth: true,
        },
        hideChildrenInMenu: false,
        children: [{
                name: "Confirm Log Users",
                path: "/confirm-log/users",
                component: () =>
                    import ("@/views/ConfirmLog/SystemUser.vue"),
                meta: {
                    title: "system-user-title",
                    subTitle: "system-management-user-subTitle",
                },
            },
            {
                name: "Confirm Log CMS",
                path: "/confirm-log/cms",
                component: () =>
                    import ("@/views/ConfirmLog/SystemCMS.vue"),
                meta: {
                    title: "cms-title",
                    subTitle: "cms-subTitle",
                },
            },
            {
                path: "/confirm-log/teachers",
                component: () =>
                    import ("@/views/ConfirmLog/SystemTeachers.vue"),
                meta: {
                    title: "system-teacher-title",
                    subTitle: "system-teacher-subtitle",
                },
            },
            {
                path: "/confirm-log/admin",
                component: () =>
                    import ("@/views/ConfirmLog/SystemAdmin.vue"),
                meta: {
                    title: "system-management-user-title",
                    subTitle: "system-management-admin-title",
                },
            },
        ],
    },
    {
        path: "/version",
        component: BasicLayout,
        meta: {
            title: "バージョン情報",
            icon: "mdi-source-branch",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [{
            path: "",
            name: "Version",
            component: () =>
                import ("@/views/Version/Version.vue"),
            meta: {
                title: "バージョン情報",
            },
        }, ],
    },
    {
        path: "/maintain",
        component: BasicLayout,
        meta: {
            title: "メンテナンス一覧",
            icon: "mdi-progress-wrench",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [{
            path: "",
            name: "Maintain",
            component: () =>
                import ("@/views/Maintain/Maintain.vue"),
            meta: {
                title: "メンテナンス一覧",
            },
        }, ],
    },
    {
        path: "/notification",
        component: BasicLayout,
        meta: {
            title: "お知らせ一覧",
            icon: "mdi-bell-outline",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [{
            path: "",
            name: "Notification",
            component: () =>
                import ("@/views/Notification/Notification.vue"),
            meta: {
                title: "お知らせ一覧",
            },
        }, ],
    },
    {
        path: "/notice",
        component: BasicLayout,
        meta: {
            title: "プッシュ配信",
            icon: "mdi-bullhorn",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [{
            path: "",
            name: "Notice",
            component: () =>
                import ("@/views/Notice/Notice.vue"),
            meta: {
                title: "プッシュ配信",
            },
        }, ],
    },
    {
        path: "*",
        name: "404",
        hidden: true,
        component: () =>
            import ("@/views/exception/err404"),
    },
];
export default routes;